import React, { Component } from 'react';
import Collapsible from './Collapsible';
import FontAwesome from 'react-fontawesome';
import Image from './Image.jsx';
import ControlBar from './ControlBar.jsx';
import ReactTimeout from 'react-timeout';
//import ReactDOM from 'react-dom';

class Viewer extends Component {
	
	constructor(props) {
		super(props);
		this.tzoptions = { timeZone: 'UTC', timeZoneName: 'short' };
		
		this.state = {
			isOpen: false,
			activePic:this.props.active,
			inTransition: false,
			activeDate:this.props.date.toLocaleTimeString('en-GB',this.tzoptions)
		};
		
		// regular instance vars
		this.viewing = true;
		
		this.incomingTitle = "LIVE FEED // INCOMING";
		this.incomingIcon = "bolt";
		this.incomingAlt = "Loading";
		this.incomingUrl = "/wp-content/themes/thurschild/assets/images/loading.gif";
		this.incomingWidth = 300;
		this.incomingHeight = 200;
		
		// This binding is necessary to make `this` work in the callback
		this.switchPic = this.switchPic.bind(this);
		this.openSlide = this.openSlide.bind(this);
		this.handleOpenClick = this.handleOpenClick.bind(this);
		this.handleCloseClick = this.handleCloseClick.bind(this);
	
	}
	
    
    componentWillReceiveProps(nextProps) {
	    
	    console.log(nextProps.active + ' ' + this.props.active);
	    
		if(nextProps.active !== this.props.active) {
		    // request to update existing slide
			this.setState({
				inTransition: true,
				isOpen: false
			});
		}
		this.props.setTimeout(this.switchPic, this.props.transitionTime);
    }
    
    
	componentDidUpdate(prevProps, prevState) {
		//console.log(JSON.stringify(this.state, null, 2));
	}
	switchPic() {
		// collapsible should be closed now.
		let newState = {
			activePic:this.props.active,
			inTransition:false,
			activeDate:this.props.date.toLocaleTimeString('en-GB',this.tzoptions)
		}
		this.setState(newState, this.openSlide);
	}
	openSlide(){
		//console.log('openSlide viewing: ' + this.viewing);
		if(this.viewing){
			this.props.setTimeout( () => {this.setState({isOpen:true})}, this.props.transitionTime/2);
			
		}
	}	

	handleOpenClick() {
		this.viewing = true;
		this.setState({isOpen: true});
		console.log('clicked: open');
		
	}
	
	handleCloseClick() {
		this.viewing = false;
		this.setState({isOpen: false});
		console.log('clicked: close');
		
	}
	
	render() {
		
		/* http://thursdayschild.local/wp-json/live-image-feed/v1/pics/ */
		let imageObj = this.props.data[this.state.activePic];
		console.log(imageObj)
		if(imageObj === undefined){
			imageObj = {
				"title": this.incomingTitle,
				"alt": this.incomingAlt,
				"trigger": this.incomingIcon,
				"sizes": {
					"medium": this.incomingUrl,
					"medium-width": this.incomingWidth,
					"medium-height": this.incomingHeight
				}
				
			}
			
		}else{
			imageObj.trigger = "window-maximize";
		}
		if(this.state.inTransition){
			imageObj.trigger = this.incomingIcon;
			imageObj.title = this.incomingTitle;
		}
		let controlBar = <ControlBar title={imageObj.title}/>;
		let trigger = <FontAwesome name={imageObj.trigger} onClick={this.handleOpenClick} />;
		
		return (
			<Collapsible 
				trigger={trigger} 
				triggerWhenOpen={<FontAwesome name='window-minimize' onClick={this.handleCloseClick} />} 
				triggerSibling={controlBar} 
				transitionTime={this.props.transitionTime} 
				triggerDisabled={this.state.inTransition}
				open={this.state.isOpen}
				>
				<div className="feed-label">LIVE FEED @ {this.state.activeDate}</div>
				<Image source={imageObj} />
			</Collapsible>
		);
	};
	
	

}

export default ReactTimeout(Viewer);



// WEBPACK FOOTER //
// ./src/Viewer.js